import { render, staticRenderFns } from "./companyinfoh5.vue?vue&type=template&id=3d066487"
import script from "./companyinfoh5.vue?vue&type=script&lang=js"
export * from "./companyinfoh5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports